<template>
  <!-- <div class="title">Forgot Password</div> -->

  <div class="logo-div">
    <!-- <img src="/assets/images/Logos/topotradeLogo1.webp" class="logo-image" /> -->
    <img :src="$store.getters.images.logo" alt="" class="logo-image">
  </div>

  <div class="subtitle">
    {{ $translation($websiteText().sign_up_login_popup_forgot_password_first_line) }}<br />
    {{ $translation($websiteText().sign_up_login_popup_forgot_password_second_line) }}
  </div>

  <hr class="mt-2 mb-2" />

  <div v-if="responseSuccess.message" class="mt-3 error-message">
    <t-inline-message :message="responseSuccess.message" severity="success" />
  </div>
  <div v-if="responseError.message" class="mt-3 error-message">
    <t-inline-message :message="responseError.message" severity="error" />
  </div>

  <div class="form">
    <t-form :onSubmit="resetPassword" :schema="schema">
      <t-input-text
        v-model="state.email"
        name="email"
        :placeholder="$translation($websiteText().my_profile_email)"
        :onInputText="onInput"
      />
      <div class="submit-btn-container">
        <t-button 
          type="submit" 
          :label="$translation($websiteText().sign_up_login_popup_forgot_password_submit_button)" 
          color="primary-color" 
          :onClick="resetPasswordValidate"
          buttonClass="signin-btn-class" 
        />
      </div>
    </t-form>
  </div>
</template>
<script>
import { reactive } from "@vue/reactivity";
import TButton from "../../../common/components/buttons/TButton.vue";
import TInputText from "../../../common/components/input-text/TInputText.vue";
import TForm from "../../../common/components/TForm.vue";

import * as Yup from "yup";

import store from "../../../store";
import { AUTH_RESET_PASSWORD_REQUEST } from "../store/actions";
import TInlineMessage from "../../../common/components/messages/TInlineMessage.vue";
// import { useI18n } from "vue-i18n";
import { SHOW_TOAST_MESSAGE } from '../../../common/store/actions';
import GeneralHelper from '../../../common/helpers/GeneralHelper';
export default {
  name:"ForgetPassword",
  components: {
    TButton,
    TInputText,
    TForm,
    TInlineMessage,
  },

  setup() {
    let responseSuccess = reactive({
      message: "",
    });

    let responseError = reactive({
      message: "",
    });

    const state = reactive({
      email: "",
    });

    const onInput = () => {
      responseSuccess.message = "";
      responseError.message = "";
    };

    // const i18n = useI18n();

    const schema = Yup.object().shape({
      email: Yup.string()
        .required()
        .email(),
    });

const resetPasswordValidate=()=>{
  schema
        .validate(state, { abortEarly: false })
        .then()
        .catch((e) => {
           for(let i=0;i<e.errors.length;i++)
           {store.dispatch(
            SHOW_TOAST_MESSAGE,
            GeneralHelper.buildMessage(3, e.errors[i])
          );}
        });
};

    const resetPassword = () => {
      store
        .dispatch(AUTH_RESET_PASSWORD_REQUEST, {
          email: state.email,
          redirectUrl:
            window.location.origin +
            "/" +
            store.getters.locale +
            "/newPassword",
        })
        .then((resp) => {
          responseSuccess.message = i18n.t(
            "Reset Password Email Sent"
          );
        })
        .catch((e) => {
          if (e.response && e.response.data) {
            responseError.message = e.response.data.message;
            store.dispatch(
              SHOW_TOAST_MESSAGE,
              GeneralHelper.buildMessage(3, e.response.data.message)
            );
          }
        });
    };

    return {
      schema,
      state,
      responseSuccess,
      responseError,
      resetPassword,
      onInput,
      store,
      resetPasswordValidate,
    };
  },
};
</script>
<style lang="scss" scoped>
  @import '../style/auth.scss';
</style>
